import { pxToREM } from './utils'

export const uiSizes = {
  ui_02: pxToREM({ px: 2 }),
  ui_04: pxToREM({ px: 4 }),
  ui_08: pxToREM({ px: 8 }),
  ui_12: pxToREM({ px: 12 }),
  ui_16: pxToREM({ px: 16 }),
  ui_20: pxToREM({ px: 20 }),
  ui_24: pxToREM({ px: 24 }),
  ui_28: pxToREM({ px: 28 }),
  ui_32: pxToREM({ px: 32 }),
  ui_40: pxToREM({ px: 40 }),
  ui_48: pxToREM({ px: 48 })
}
